/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Panel_LoadingInputs */

const en_tasks_panel_loading = /** @type {(inputs: Tasks_Panel_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

const fr_tasks_panel_loading = /** @type {(inputs: Tasks_Panel_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const ms_sg2_tasks_panel_loading = /** @type {(inputs: Tasks_Panel_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuatkan…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Tasks_Panel_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_panel_loading = /** @type {((inputs?: Tasks_Panel_LoadingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Panel_LoadingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_panel_loading(inputs)
	if (locale === "fr") return fr_tasks_panel_loading(inputs)
	return ms_sg2_tasks_panel_loading(inputs)
});